import { render, staticRenderFns } from "./GarantiaFalla.vue?vue&type=template&id=aa0640ea"
import script from "./GarantiaFalla.vue?vue&type=script&lang=js"
export * from "./GarantiaFalla.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports